import EmployeeIExitInterviewForm from '../../../shared/components/employee/employee-exit-interview-form'
import Layout from '../../../shared/components/ui/layout'
import Image from '../../../shared/assets/images/employeeInterviewQuestionsImage.svg'

const EmployeeIExitInterview = () => {
  return (
    <Layout Image={Image}>
      <EmployeeIExitInterviewForm />
    </Layout>
  )
}

export default EmployeeIExitInterview
